import './form.sass';

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setLocale, Translate } from 'react-redux-i18n';

import { isLoginSuccess } from 'helpers/auth';
import request from 'actions/request';
import transmit from 'actions/transmit';
import normalizeLocale from 'helpers/locale';

class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      submitting: false
    };
  }

  auth(event) {
    event.preventDefault();

    if (this.state.submitting) {
      return;
    }

    this.setState({ submitting: true, message: '' });

    this.props.request(
      ['users', 'login'],
      'post',
      'USER_LOGIN', {
        login: this.loginInput.value,
        pass: this.passInput.value
      }
    ).then((response) => {
      if (!isLoginSuccess(response)) {
        this.setState({
          submitting: false,
          message: (response && response.message) || 'userUnexist'
        });
        return;
      }

      this.props.transmit(null, setLocale(normalizeLocale(response.lang)), true);
    }, (response) => {
      this.props.transmit('LOGIN_FAILED', response);
      this.setState({
        submitting: false,
        message: (response && response.message) || 'userUnexist'
      });
    });
  }

  changeLanguage(nextLang, event) {
    if (event) {
      event.preventDefault();
    }

    const language = normalizeLocale(nextLang);
    const locale = normalizeLocale(this.props.locale);
    if (language === locale) {
      return;
    }

    this.props.transmit(null, setLocale(language), true);
  }

  buildLanguages() {
    const preferredOrder = ['uk', 'en', 'es', 'de'];
    const locale = normalizeLocale(this.props.locale);
    const codes = Object.keys(this.props.availableLanguages || {})
      .filter((item) => item.length === 2)
      .sort((a, b) => {
        const indexA = preferredOrder.indexOf(a.toLowerCase());
        const indexB = preferredOrder.indexOf(b.toLowerCase());
        return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
      });

    return codes.map((item) => {
        const code = item.toUpperCase();
        const isActive = item.toLowerCase() === locale;

        return (
          <button
            key={ code }
            type='button'
            className={ 'login-form__lang' + (isActive ? ' is-active' : '') }
            data-lang={ item }
            onClick={ () => this.changeLanguage(item) }
          >
            { code }
          </button>
        );
      });
  }

  render() {
    return (
      <form className='login-form' onSubmit={ this.auth.bind(this) }>
        <div className='login-form__brand'>
          <span className='login-form__mark' aria-hidden='true' />
          <span className='login-form__brand-name'>Vehiclesos</span>
        </div>

        <h1 className='login-form__header' id='login-modal-title'>
          <Translate value='login.form.welcome'/>
        </h1>
        <p className='login-form__lead'>
          <Translate value='login.form.to'/>
        </p>

        { this.state.message !== '' && (
          <div className='login-form__message-row'>
            <Translate value={ 'login.form.' + this.state.message }/>
          </div>
        ) }

        <label className='login-form__field'>
          <span className='login-form__label'>
            <Translate value='login.form.userName'/>
          </span>
          <input
            name='login'
            ref={ (textInput) => { this.loginInput = textInput; } }
            className='form-control login-form__form-control'
            type='text'
            autoComplete='username'
            autoFocus
          />
        </label>

        <label className='login-form__field'>
          <span className='login-form__label'>
            <Translate value='login.form.password'/>
          </span>
          <input
            name='pass'
            ref={ (textInput) => { this.passInput = textInput; } }
            className='form-control login-form__form-control'
            type='password'
            autoComplete='current-password'
          />
        </label>

        <button
          type='submit'
          className='btn login-form__btn'
          disabled={ this.state.submitting }
        >
          <Translate value='login.form.authorize'/>
        </button>

        <div className='login-form__langs'>
          { this.buildLanguages() }
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {
    locale: state.i18n.locale,
    availableLanguages: state.i18n.translations
  };
}

function mapDispatchToProps(dispatch) {
  return {
    request: bindActionCreators(request, dispatch),
    transmit: bindActionCreators(transmit, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form);
